import { render } from "./cookiesConsent.vue?vue&type=template&id=31906e64&scoped=true"
import script from "./cookiesConsent.vue?vue&type=script&lang=js"
export * from "./cookiesConsent.vue?vue&type=script&lang=js"

import "./cookiesConsent.vue?vue&type=style&index=0&id=31906e64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31906e64"]])

export default __exports__